export const APP_CONFIG = {
  // baseDomain: 'http://127.0.0.1:8300',
  baseDomain: 'https://clapi.thanhconglogistics.com',
  mediaDomain: 'https://media.thanhconglogistics.com',
  authSetting: {
    tokenName: 'token',
  },
  settings: {
    main_domain: 'https://thanhconglogistics.com',
    firebase_prefix: 'thanhconglogistics',
    firebase_storage: 'https://firebasestorage.googleapis.com/v0/b/oee-app-cc5a1.appspot.com/o'
  },
  eventBusAction: {
    disableMenuLeft: 'disableMenuLeft',
    disableHeader: 'disableHeader',
    showHideMenuLeft: 'showHideMenuLeft',
    reloadWithdrawalHistories: 'reloadWithdrawalHistories',
    reloadNotification: 'reloadNotification'
  },
  stateKey: {
    authStore: 'authStore',
    commonStore: 'commonStore',
    cartState: 'cartState',
  },
  sqlDateFormat: 'YYYY-MM-DD hh:mm:ss',
  notifyRefreshTime: 30
};
